'use strict';Object.defineProperty(exports,'__esModule',{value:!0});var _createColorPalette=require('./createColorPalette'),_createColorPalette2=_interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var gold={1:'#fff5dd',2:'#ffe29c',3:'#ffd560',4:'#e8b520',5:'#be8a0d',6:'#9a6f07',7:'#855f07',8:'#715005',9:'#5a4206',10:'#3b2b04',inflection:6};exports.default=(0,_createColorPalette2.default)(gold,'gold');


/** WEBPACK FOOTER **
 ** ./~/@vitalsource/vstui/colors/gold.js
 **/